module.exports = __webpack_public_path__ + "static/media/cds.8b53a58f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/cds.svg
// module id = 3075
// module chunks = 0